import React, { useEffect, useState } from 'react';
import { apiClient } from '../utils/api.js';
import Header from '../components/Header.js';
import Footer from '../components/Footer.js';
import '../styles/pages/Admin.css';

const Admin = () => {
  const [requests, setRequests] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchRequests = async () => {
      try {
        const response = await apiClient.get('/api/contact');
        setRequests(response.data);
      } catch (err) {
        setError('Failed to load requests. Please try again later.');
        console.error('Error fetching contact requests:', err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchRequests();
  }, []);

  const renderContent = () => {
    if (isLoading) {
      return <div className="admin-status">Loading requests...</div>;
    }

    if (error) {
      return <div className="admin-status error">{error}</div>;
    }

    if (!requests.length) {
      return <div className="admin-status">No requests yet.</div>;
    }

    return (
      <div className="admin-table-wrapper">
        <table className="admin-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Service</th>
              <th>Preferred Date</th>
              <th>Address</th>
              <th>Message</th>
              <th>Submitted</th>
            </tr>
          </thead>
          <tbody>
            {requests.map((request) => (
              <tr key={request._id}>
                <td>{request.name}</td>
                <td>{request.email}</td>
                <td>{request.phone}</td>
                <td className={`service-badge service-${request.service}`}>
                  {request.service === 'moving' && 'Moving'}
                  {request.service === 'junk-removal' && 'Junk Removal'}
                  {request.service === 'both' && 'Moving & Junk Removal'}
                </td>
                <td>{request.preferredDate ? new Date(request.preferredDate).toLocaleDateString() : '—'}</td>
                <td>{request.address || '—'}</td>
                <td className="message-cell">{request.message}</td>
                <td>{new Date(request.createdAt).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <>
      <Header />
      <main className="admin-page">
        <section className="admin-header">
          <h1>Customer Requests</h1>
          <p>View incoming requests for moving and junk removal services.</p>
        </section>
        {renderContent()}
      </main>
      <Footer />
    </>
  );
};

export default Admin;

